<h2 mat-dialog-title>
    {{ 'task_details_dialog.kudos.title' | translate}}
</h2>

<mat-dialog-content class="dialog-content-pad-10 poll-aggregated-results">
    @if(loading){
        <p class="text-secondary pb-3"><i class="fa-solid fa-circle-notch fa-spin"></i> {{ 'task_details_dialog.loading' | translate}}</p>
    } @else {
        <div class="row pb-5 px-5">
            <h3 class="col-md-8 mx-auto text-center text-secondary fw-normal fst-italic fs-5 py-3">
            </h3>
            <div class="col-md-7 d-flex flex-column justify-content-center align-items-center">
                <div class="media card my-1 pt-2 pb-0 task-content kudos-card" id="{{kudos.id}}"
                     [ngClass]="{'focus-task': threadInCreation}">        
                        
                        <kudos-task [task]="kudos"
                            (onReported)="onReported()"></kudos-task>
                       
                        <div class="media-bottom card-bottom" [ngClass]="threadInCreation ? 'pb-4' : 'pb-2'">
                            <tm-reactions [timelineItem]="kudos"
                                            [showDiscussButton]="false"
                                            (onReacted)="onReacted($event)"/>
                            @if(kudos.threads.length > 0 || threadInCreation){
                                <tm-task-threads [task]="kudos" #threadsComponent
                                                    [userInfos]="userInfos"
                                                    [threadInCreation]="false"
                                                    (onCancelCreation)="onCancelCreation()"
                                                    (onThreadCreation)="onThreadCreation($event)"></tm-task-threads>
                            }
                        </div>
                </div>
            </div>
            <div class="col-md-5 d-flex flex-column justify-content-center align-items-center">
                <div class="alert alert-light p-4">
                    <div class="pb-3">
                        You posted this Kudos in response to the feedback <i [matTooltip]="kudos.date | date: 'mediumDate'" matTooltipPosition="above">{{kudos.date | date_time_from_now }}</i> in <span class="badge rounded-pill text-bg-light">{{kudos.team.name}}</span> 
                        <small class="d-block">
                            <a class="review-link" 
                                [matTooltip]="'taskbook.task.view_on_timeline' | translate" matTooltipPosition="above" 
                                [routerLink]="['/backlog/kudosItem/', kudos.id]" target="_blank">
                                view item in your backlog<i class="fas fa-arrow-up-right-from-square ps-1 link-underline-opacity-0"></i>
                            </a>
                        </small>
                    </div>
                </div>
            </div>
        </div>
    }
</mat-dialog-content>

<mat-dialog-actions class="justify-content-end">
    <button type="button"
            class="btn btn-default"
            (click)="close()">{{'close' | translate}}</button>
</mat-dialog-actions>